import StandingsTable from "./StandingsTable";
import {
    groupANote,
    standingsGroupA,
    standingsGroupB,
} from "../../data/standings";

export default function StandingsSection() {
    return (
        <section className="w-full bg-[#071120] py-8 md:py-10">
            <div className="mx-auto max-w-[1400px] px-4 md:px-6 lg:px-8">
                <div className="mb-6">
                    <h2 className="text-2xl font-black uppercase tracking-wide text-white md:text-3xl">
                        Classements
                    </h2>
                    <p className="mt-2 text-sm text-white/65 md:text-base">
                        Suivez le classement du Groupe A et du Groupe B.
                    </p>
                </div>

                <div className="grid gap-6 xl:grid-cols-2">
                    <StandingsTable
                        title="Groupe A"
                        rows={standingsGroupA}
                        note={groupANote}
                    />
                    <StandingsTable
                        title="Groupe B"
                        rows={standingsGroupB}
                    />
                </div>
            </div>
        </section>
    );
}